import { AddressData } from 'pages/AuthNew/EnterAddress'
import { SetSecurityQuestionInterface, SignupInterface1 } from 'types/UserInterface'
import AxiosInstance, { ApiNoAuth } from './apiAdapter'

export const signup = (userData: SignupInterface1) =>
  ApiNoAuth.post(`/users/sign-up`, userData)

export const newSignup = (userData: { email: string, password: string }) =>
  ApiNoAuth.post(`/user-registration/create`, userData)

export const newCreateProfile = (userData: {
  firstName: string,
  middleName: string,
  lastName: string,
  mobileNumber: string,
  dateOfBirth: string,
  countryId: string | number
}) =>
  AxiosInstance.post(`/user-registration/personal-information`, userData)

export const newAddAddress = (userData: AddressData) =>
  AxiosInstance.post(`/user-registration/address`, userData)

export const newValidateEmail = (userData: { email: string, otp: string }) =>
  ApiNoAuth.post(`/user-registration/validate-email`, userData)

export const newValidateMobile = (userData: { otp: string }) =>
  AxiosInstance.post(`/user-registration/validate-mobile-number`, userData)

export const getCountries = () =>
  ApiNoAuth.get(`countries`)

export const getSecurityQuestions = () =>
  AxiosInstance.get(`security-questions`)

export const getUserAddress = () =>
  AxiosInstance.get(`/users/find-address`)

export const setSecurityQuestions = (data: { data: SetSecurityQuestionInterface[] }) =>
  AxiosInstance.post(`/user-registration/security-question-setup`, data)

export const getSecurityQuestionsByUser = () =>
  AxiosInstance.get(`/security-questions/findByUser`)

export const changeSecurityQuestions = (data: {
  id: string;
  question: string;
  answer: string;
}) =>
  AxiosInstance.put(`/users/change-security-question`, data)


export const getUserAddressByStatusList = (status: string[]) =>
  AxiosInstance.get(`/user-registration/find-list-by-user-address-and-status?appStatuses=${status.join(",")}`)